import { ApiResult } from 'interfaces/APITypes';

import { contentInstance, makeRequest } from './client';

export const getGames = async (): Promise<ApiResult> => {
  return makeRequest(contentInstance.get('/games'));
};
